/*
export function someMutation (state) {
}
*/

export function SET_DOMINIOS(state, list) {
  state.dominios = list;
}
